import { z } from "zod";

const BookingExtraResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.object({
        id: z.string().uuid(),
        booking_room_id: z.string().uuid(),
        inventory_id: z.string().uuid().optional().nullable(),
        item_name: z.string(),
        qty: z.number(),
        amount: z.string(),
        date: z.string(),
        created_at: z.string(),
        updated_at: z.string(),
    }),
});

export { BookingExtraResponseSchema };
export type BookingExtraResponse = z.infer<typeof BookingExtraResponseSchema>;
